<script lang=ts>
	import { parsesTranslations, registerTranslations } from "./ts/Translations";
	import { createLocaleContext, getLocaleContext } from "./ts/Locale.svelte";
  import { data as Translations } from "./GlobalTranslations"
      import { onMount } from "svelte"

  let locale = getLocaleContext()
  if( ! locale ) locale = createLocaleContext("cs")

  onMount( () => {
    window._locale = locale
  })

  const tr = parsesTranslations(Translations)
  registerTranslations(tr)
  
  let { children = undefined } = $props()
</script>

{@render children?.()}